<template>
    <div class="f-topic-edit">
        <div class="f-topic-edit-route">
            <router-link class="f-topic-edit-route-hover" to="/">首页</router-link>
            <span class="f-topic-edit-route-arrow">></span>
            <span class="f-topic-edit-route-hover">发帖页</span>
        </div>

        <div class="f-topic-edit-wrapper">
            <div class="f-topic-edit-title">我要发帖</div>
            <div class="f-topic-edit-content"
                v-if="Object.keys(pageConfig).length">
                <div class="f-topic-edit-content-tags"
                    v-if="extConfig[0] && extConfig[0].tagInfo && extConfig[0].tagInfo.length">
                    <span class="f-topic-edit-content-tags-label">问题类型</span>
                    <div class="f-topic-edit-content-tags-tags">
                        <span v-for="(item, index) in extConfig[0].tagInfo"
                            :key="item.id"
                            @click="changeTag(item.id, index)"
                            :class="{'f-topic-edit-content-tags-name': true,
                                'f-topic-edit-content-tags-name-active': item.id === activeTag}">
                            {{item.name}}
                            <!-- 渲染提示文案，根据样式来展示和切换,每一个循环到的 item，文案内容为 item.ext.tip-->
                            <span v-if="item.ext.tip"
                                class="f-topic-edit-content-tags-tip">{{item.ext.tip}}</span>
                        </span>
                    </div>
                </div>

                <!-- 帖子标题 config -->
                <render-component :form-config="titleConfig"></render-component>

                <div v-if="extConfig[0] && extConfig[0].tagInfo && extConfig[0].tagInfo.length
                    && Object.keys(extConfig[0].tagInfo[activeTagIndex].ext).length">
                    <div v-for="ext in extConfig[0].tagInfo[activeTagIndex].ext.extBeanConfig"
                        :key="ext.id">
                        <!-- 该处的 render 渲染 extBeanConfig 数组 -->
                        <render-component
                            v-if="isRender(ext)"
                            :form-config="pageConfig[ext.template]"
                            :form-name="ext.template"
                            :editor-place-holder="ext.placeholder"
                            @changeEditPlaceholder="changeEditPlaceholder">
                        </render-component>
                    </div>
                </div>

                <div class="f-topic-edit-content-editor">
                    <span class="f-topic-edit-content-editor-label">
                        <span class="f-topic-edit-content-editor-label-required">*</span>
                        <span>详细描述</span>
                    </span>
                    <editor-component ref="childEditor"
                        style="width: 905px; display: inline-block;"
                        :editorid="'topicEditor'"
                        @change="notChangeEditor">
                    </editor-component>
                </div>

                <veui-button class="f-topic-edit-content-btn"
                    :loading="submitLoading"
                    @click="submitTopic">发布帖子</veui-button>
            </div>
        </div>
    </div>
</template>

<style lang="less">
    @import '../../assets/less/views/edit-topic/edit-module.less';
</style>

<script>
import RenderComponent from './components/RenderComponent.vue';
import Editor from '../components/tinyEditor';
import {Button} from 'veui';
import {mapState, mapActions} from 'vuex';
import {debounce} from '@/utils/debounceThrottle.js';
import {Tip} from '@/utils/errorCode';

export default {
    components: {
        'render-component': RenderComponent,
        'editor-component': Editor,
        'veui-button': Button
    },
    data() {
        return {
            errorImg: this.$store.state.home.errorImg,
            submitLoading: false,
            showTags: false,
            inputVisible: false,
            inputValue: ''
        };
    },
    computed: {
        ...mapState({
            initPlaceholder: state => state.editTopic.initPlaceholder,
            pageConfig: state => state.editTopic.pageConfig,
            // 返回的是 页面的 pf_options
            extConfig: state => state.editTopic.extConfig,
            // 顶部的 tag 信息
            titleConfig: state => state.editTopic.titleConfig,
            dynamicTags: state => state.editTopic.dynamicTags,
            isInputSthing: state => state.editTopic.isInputSthing,
            hasNull: state => state.editTopic.hasNull,
            activeTag: state => state.editTopic.activeTag,
            activeTagIndex: state => state.editTopic.activeTagIndex
        })
    },
    mounted() {
        this.$store.state.editTopic.dynamicTags = [];
        let params = {
            routeName: this.$route.name
        };
        let id = this.$route.params.id;
        let idx = id - 1;
        switch (this.$route.name) {
            case 'editTopic':
                params.type = 1;
                params.id = this.$route.params.topicid;
                break;
            case 'addTopic':
            default:
                if (Object.keys(this.$route.query).length > 0) {
                    Object.assign(params, this.$route.query);
                }
                break;
        }
        this.$store.dispatch('init', params)
            .then(() => {
                // 设置默认问题类型
                if (params.optionids) {
                    try {
                        this.pageConfig.suggestTypes.defaultValue = JSON.parse(params.optionids);
                    }
                    catch (e) {
                        console.warn(e);
                    }
                }

                let placeHolder = this.initPlaceholder;
                if (placeHolder.length > 0) {
                    this.$nextTick(() => {
                        this.$refs.childEditor.setContent(placeHolder);
                    });
                    if (this.$route.params.id) {
                        this.changeTab(id, idx);
                    }
                }
            })
            .catch(errmsg => {
                console.warn(errmsg);
                if (errmsg === Tip.notLogin) {
                    this.$store.dispatch('navToExit');
                }
                else {
                    this.$router.replace('/');
                }
            });
    },

    destroyed() {
        this.$store.commit('clearPageData');
        // 页面销毁同时，移除昊天镜蒙层
        this.$store.dispatch('removeMkdMask');
    },
    methods: {
        ...mapActions(['notChangeEditor']),
        isRender(ext) {
            if (!ext.displayConditions) {
                return true;
            }
            for (let conditionItem of ext.displayConditions) {
                if (conditionItem.conditionType === '==='
                        && this.pageConfig[conditionItem.sourseId].defaultValue !== conditionItem.value) {
                    return false;
                }
                if (conditionItem.conditionType === '!=='
                        && this.pageConfig[conditionItem.sourseId].defaultValue === conditionItem.value) {
                    return false;
                }
            }
            return true;
        },

        handleClose(tag) {
            this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
        },

        showInput() {
            this.inputVisible = true;
            this.$nextTick(_ => {
                this.$refs.saveTagInput.$refs.input.focus();
            });
        },

        handleInputConfirm() {
            let inputValue = this.inputValue;
            if (inputValue) {
                this.dynamicTags.push(inputValue);
            }
            this.inputVisible = false;
            this.inputValue = '';
            this.$store.dispatch('setTags', this.dynamicTags);
        },
        changeTag(id, idx) {
            this.$store.dispatch('chooseTag', {id, idx});
            this.changeEditPlaceholder(this.initPlaceholder);
        },
        changeEditPlaceholder(placeHolder) {
            if (!this.isInputSthing) {
                this.$nextTick(() => {
                    this.$refs.childEditor.setContent(placeHolder);
                });
            }
        },
        // 点击发布帖子
        submitTopic: debounce(function () {

            let content = this.$refs.childEditor.getContent();
            let pureText = this.$refs.childEditor.getText();

            this.$store.dispatch('checkForm', {content, pureText});
            if (!this.hasNull) {
                this.$store.dispatch('showMkd').then(({ds, tk}) => {
                    this.submitLoading = true;
                    this.$store.dispatch('submit', {ds, tk})
                        .then(data => {
                            this.submitLoading = false;
                            if (data) {
                                setTimeout(() => {
                                    this.$router.push({name: 'topicContent', params: {topicid: data.topicId}});
                                }, 500);
                            }
                        });
                }).catch(() => this.submitLoading = false);
            }
        })
    }
};
</script>
